/* eslint-disable i18next/no-literal-string -- "Image pending" is a dev-only placeholder, never ships */
import { cn } from "~/lib/utils";
import { Picture } from "~/components/ui/picture";

interface ImageOrPlaceholderProps {
  src?: string;
  alt?: string;
  className?: string;
  /** `eager` for an above-the-fold image (the gallery's main image is the PDP's LCP); lazy otherwise. */
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
}

// Renders the real asset when provided; otherwise a neutral placeholder box,
// matching Figma's own FPO (for-placement-only) convention for photography
// that hasn't been delivered yet. Dev-only text — this branch never ships,
// since a real `image` is always required before a section goes live.
export function ImageOrPlaceholder({ src, alt, className, loading, fetchPriority }: ImageOrPlaceholderProps) {
  if (src) {
    return <Picture src={src} alt={alt ?? ""} loading={loading} fetchPriority={fetchPriority} className={cn("h-full w-full object-contain", className)} />;
  }
  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center rounded-2xl bg-neutral-100 text-xs font-medium text-neutral-400",
        className,
      )}
    >
      Image pending
    </div>
  );
}
